import { Component } from '@angular/core';
import { PlatformApiWpService } from '../services/platform-apiwp.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-token',
  templateUrl: './verify-token.component.html',
  styleUrls: ['./verify-token.component.scss']
})
export class VerifyTokenComponent {
  email!: string;
  token!: string;
  delfiToken: any;

  constructor(
    private platformApiWpService: PlatformApiWpService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.email = this.activatedRoute.snapshot.queryParams['email'];
    this.token = this.activatedRoute.snapshot.queryParams['token'];
    this.delfiToken = this.activatedRoute.snapshot.queryParams['delfi_token'];

    if ((!this.email || !this.token) && !this.delfiToken) {
      console.log('no email or token');
      return;
    }

    this.verifyEmail();

  }

  verifyEmail() {
    // console.log('verifyEmail', this.email, this.token);
    this.platformApiWpService.postRequest('/msc/v1/verifyEmail', { email: this.email, token: this.token, delfi_token: this.delfiToken }).then((sub: any) => {
      sub.subscribe((response: any) => {
        // console.log(response);
        if (response?.status == 'ok') {
          this.registerStep(response.payload);
        }
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  registerStep(payload: any) {
    // console.log('registerStep', payload);
    const transaction = payload?._trans
    this.platformApiWpService.postRequest('/msc/v1/registerStep', { _trans: transaction }).then((sub: any) => {
      sub.subscribe((response: any) => {
        // console.log(response);
        if (response?.status == 'ok') {

          const promises = [
            this.registerStepGeneric('registerStepData', response.payload),
            this.registerStepGeneric('registerStepAnalysis', response.payload),
            this.registerStepGeneric('registerStepSalesforce', response.payload),
            this.registerStepGeneric('registerStepActiveCampaign', response.payload),
            
            // this.registerStepData(response.payload),
            // this.registerStepAnalysis(response.payload)
          ];
          Promise.all(promises).finally(() => {
            let accessToken = response.payload?.res?.access_token;
            if(accessToken) {
              this.router.navigate([environment.routingBasePath +'/login'], { queryParams: { access_token: accessToken } });
            } else if(this.delfiToken) {
              this.router.navigate([environment.routingBasePath +'/login'], { queryParams: { delfi_token: this.delfiToken } });
            } else {
              this.router.navigate([environment.routingBasePath +'/login']);
            }
          })
        }
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  registerStepGeneric(path: string, payload: any) {
    // console.log('registerStepData', payload);
    const transaction = payload?._trans
    return new Promise((resolve, reject) => {
      this.platformApiWpService.postRequest('/msc/v1/' + path, { _trans: transaction }).then((sub: any) => {
        sub
          .pipe(catchError((err) => {
            console.error(err);
            reject(err);
            return err;
          }))
          .subscribe((response: any) => {
            // console.log(response);
            resolve(response)
          });
      }).catch((err) => {
        console.error(err);
        reject(err)
      });
    })

  }

  registerStepData(payload: any) {
    // console.log('registerStepData', payload);
    const transaction = payload?._trans
    return new Promise((resolve, reject) => {
      this.platformApiWpService.postRequest('/msc/v1/registerStepData', { _trans: transaction }).then((sub: any) => {
        sub
          .pipe(catchError((err) => {
            console.error(err);
            reject(err);
            return err;
          }))
          .subscribe((response: any) => {
            // console.log(response);
            resolve(response)
          });
      }).catch((err) => {
        console.error(err);
        reject(err)
      });
    })

  }

  registerStepAnalysis(payload: any) {
    // console.log('registerStepAnalysis', payload);
    const transaction = payload?._trans

    return new Promise((resolve, reject) => {
      this.platformApiWpService.postRequest('/msc/v1/registerStepAnalysis', { _trans: transaction }).then((sub: any) => {
        sub
          .pipe(catchError((err) => {
            console.error(err);
            reject(err);
            return err;
          }))
          .subscribe((response: any) => {
            // console.log(response);
            resolve(response)
          });
      }).catch((err) => {
        console.error(err);
        reject(err)
      });
    })

  }

}
